//
// gcatCodeTextColor
//
const gcatCodeTextColorsSrc = {
  police: '#091493',
  fire: '#800000',
  medical: '#035018',
  security: '#973d0D',
  // 'town',
  social: '#644c34',
  // 'services',
  // 'paxity', 'users', 'rescue',
  // events:
  // facilities: '#091493',
  // it:
  // services:
  // paxity:
};

const gcatCodeTextColors = (gcatCode) => (
  gcatCodeTextColorsSrc[gcatCode] || '#202020');

export default gcatCodeTextColors;
